import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Container, MaskText, Reveal, Logo } from "./primitives";

const API = process.env.REACT_APP_BACKEND_URL;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!API) return;
    setLoading(true);
    try {
      await axios.post(`${API}/api/newsletter`, { email });
      toast.success("Inscrição confirmada! Você receberá os próximos insights.");
      setEmail("");
    } catch {
      toast.error("Não foi possível inscrever este e-mail.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="grain relative overflow-hidden bg-[#1238CE] py-20 text-white lg:py-28" data-testid="newsletter-section">
      <Container className="relative grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Logo className="h-12 w-12" />
          <MaskText className="font-display mt-8 text-3xl font-bold leading-[1.02] tracking-[-0.03em] sm:text-5xl"
            lines={["Insights práticos de Estratégia,", <>Marketing e <span className="text-[#CCFF00]">Vendas.</span></>]} />
          <Reveal><p className="mt-5 max-w-md text-base leading-relaxed text-white/85">O que realmente funciona para construir resultados sólidos, direto no seu e-mail. Sem spam.</p></Reveal>
        </div>
        <Reveal className="lg:col-span-5">
          <form onSubmit={submit} className="flex flex-col gap-3 rounded-full sm:flex-row sm:bg-white/10 sm:p-1.5 sm:backdrop-blur" data-testid="newsletter-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com"
              className="flex-1 rounded-full bg-white/10 px-5 py-3.5 text-base text-white outline-none placeholder:text-white/70 sm:bg-transparent" data-testid="newsletter-form-email-input" />
            <button type="submit" disabled={loading} data-testid="newsletter-form-submit-button"
              className="rounded-full bg-[#CCFF00] px-6 py-3.5 text-sm font-bold text-[#060B19] transition-transform duration-300 hover:-translate-y-0.5 disabled:opacity-70">
              {loading ? "Enviando..." : "Receber insights"}
            </button>
          </form>
        </Reveal>
      </Container>
    </section>
  );
};
